import { Hand } from "lucide-react";

export default function NonSpeakingPanel({ text, dark = false }) {
  if (!text) return null;
  return (
    <section
      data-testid="non-speaking-panel"
      className={`rounded-xl border-l-4 border-l-[#bf6163] p-5 sm:p-6 shadow-lg ${
        dark ? "bg-[#221517] text-[#dfd8da]" : "bg-[#221517] text-[#dfd8da]"
      }`}
    >
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-lg bg-[#bf6163] text-[#221517] flex items-center justify-center shrink-0">
          <Hand size={18} aria-hidden="true" />
        </div>
        <h2 className="text-sm uppercase tracking-widest font-extrabold text-[#ffdedf]">
          Ways to play without speaking
        </h2>
      </div>
      <p className="mt-3 text-base leading-relaxed">{text}</p>
    </section>
  );
}
